import { createElement } from 'react'
import { Modal } from 'antd'
import { ComponentController } from './component_controller'
import { DispatchEvent } from '../../types'
import { Confirmable } from '../../models'
import { dispatcher } from '../pub_controller'

type ModalProps = {
  onCancel: any
  open: boolean
  title: string
  url: string
  confirmationMessage?: string
  pubChannel?: string
  width?: string
  skipConfirmation?: boolean
}

const ModalBody = (url: string) => {
  return createElement(
    'turbo-frame',
    { id: 'modal', src: url, loading: 'lazy' },
    [],
  )
}

export class TurboModalController extends ComponentController {
  closeModal(event) {
    event.preventDefault()
    this.updateProps({ open: false })
  }

  getFrame(event: CustomEvent): void {
    if (!event.detail || !event.detail.value) {
      return
    }

    const url = event.detail.value
    this.updateProps({ open: true, url })
  }

  handleCancel = (e: any) => {
    e.preventDefault()
    const { confirmationMessage, pubChannel, skipConfirmation } = this
      .props as ModalProps

    if (skipConfirmation || !confirmationMessage) {
      this.updateProps({ open: false })
      return
    }

    const confirmable = new Confirmable({
      confirmationTitle: null,
      confirmationMessage: confirmationMessage,
      pubAs: 'cancel-modal',
      pubChannel: pubChannel,
      detail: {},
    })

    dispatcher(this, 'confirm-operation', pubChannel, confirmable)

    window.addEventListener(
      `${pubChannel}:cancel-modal`,
      () => {
        this.updateProps({ open: false })
      },
      { once: true },
    )
  }

  get component() {
    return ({ title, open, url, width }: ModalProps) =>
      createElement(
        Modal,
        {
          key: title,
          title: title,
          footer: null,
          className: 'modal',
          onCancel: this.handleCancel,
          open,
          width: width || '50%',
        },
        ModalBody(url),
      )
  }

  get initialProps() {
    const props = this.propsFromData
    return {
      ...props,
      title: props['turbo-frame'],
      confirmationMessage: props.confirmation_message,
      pubChannel: props.pub_channel,
      width: props.width,
      onCancel: this.closeModal.bind(this),
    }
  }
}
